module.exports = __webpack_public_path__ + "img/cartoon.ae32a76.png";